import { createRouter, createWebHashHistory } from 'vue-router'
import Search from '../views/SearchView.vue'
import Unsubscribed from '../views/UnsubscribedView.vue'
import Subscribed from '../views/SubscribedActive.View.vue'
import Pasarela from '../views/PasarelaView.vue'

const routes = [
  {
    path: '/',
    name: 'search',
    component: Search
  },
  {
    path: '/:id',
    name: 'searchtwo',
    component: Search
  },
  {
    path: '/about/:id',
    name: 'unsubscribed',
    component: Unsubscribed
  },
  {
    path: '/active/:id',
    name: 'active',
    component: Subscribed
  },
  {
    path: '/pasarela/:orden/:amount/:code/:user',
    name: 'pasarela',
    component: Pasarela
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
